(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('PlanningController', PlanningController);

    PlanningController.$inject = ['ObservationDefinitions', 'Planning', 'EventCollections', '$scope', 'SoopkitchenUtils', '$sce', 'PlanningEventsService', 'PlanTypes', 'PlanTypesUtils', '$uibModal', 'Principal'];

    function PlanningController(ObservationDefinitions, Planning,  EventCollections, $scope, SoopkitchenUtils, $sce, PlanningEventsService, PlanTypes, PlanTypesUtils, $uibModal, Principal) {
        var vm = this;

        /**** Properties ****/
        vm.plans = [];
        vm.parentPlanLabels = [];
        vm.childPlans = [];
        vm.templatePlansBaselined = [];
        vm.templatePlansInProgress = [];
        vm.soopPlansBaselined = [];
        vm.soopPlansInProgress = [];
        vm.soopTypes = [];
        vm.allPlanStatus = [];
        vm.selectedSoopType = null;
        vm.selectedSoopLeadInstrument = null;
        vm.predicate = 'created';
        vm.reverse = true;
        vm.predicateTemplateInProgress = 'created';
        vm.predicateSoopInProgress = 'created';
        vm.reverseSoopInProgress = true;
        vm.reverseTemplateInProgress = true;
        vm.predicateSoopBaselined = 'created';
        vm.predicateTemplateBaselined = 'created';
        vm.reverseSoopBaselined = true;
        vm.reverseTemplateBaselined = true;
        vm.tabAuthorities = [];
        vm.tabAuthorities.push("ROLE_PLAN_COORDINATOR");
        vm.tabAuthorities.push("ROLE_PLAN_COORDINATOR,ROLE_INSTRUMENT_COORDINATOR,ROLE_POWER_USER");
        vm.tabAuthorities.push("ROLE_PLAN_COORDINATOR,ROLE_INSTRUMENT_TEAM_MEMBER,ROLE_INSTRUMENT_COORDINATOR,ROLE_POWER_USER");
        vm.tabAuthorities.push("ROLE_PLAN_COORDINATOR");

        vm.showDelta = {};
        vm.planStatus = {};
        vm.planStatusLabel = {};
        vm.planValidityRange = {};


        vm.planLabel = "";
        vm.planId = "";
        vm.childPlanLabel = "";
        vm.templatePlanLabel = "";
        vm.soopPlanLabel = "";
        vm.getPlanType = PlanTypesUtils.getPlanType;
        vm.templateDurationString = "";
        vm.soopDurationString = "";
        vm.moreInfo = {};
        vm.showCreateMenu = [false, false, false, false];
        vm.instruments = ['EUI', 'Metis', 'PHI', 'SPICE', 'STIX', 'SoloHI', 'EPD', 'MAG', 'RPW', 'SWA'];
        vm.isPlanCoordinator = false;
        /**** Methods ****/

        vm.createPlan = createPlan;
        vm.createChildPlan = createChildPlan;
        vm.createTemplatePlan = createTemplatePlan;
        vm.createSoopPlan = createSoopPlan;
        vm.sortPlanTable = sortPlanTable;
        vm.sortChildPlanTable = sortChildPlanTable;
        vm.sortTemplatePlanTableInProgress = sortTemplatePlanTableInProgress;
        vm.sortTemplatePlanTableBaselined = sortTemplatePlanTableBaselined;
        vm.sortSoopPlanTableInProgress = sortSoopPlanTableInProgress;
        vm.sortSoopPlanTableBaselined = sortSoopPlanTableBaselined;
        vm.formatIsoZuluDateString = SoopkitchenUtils.formatIsoZuluDateString;
        vm.loadAll = loadAll;
        vm.deletePlan = deletePlan;
        vm.renamePlan = renamePlan;
        vm.setActiveTab = setActiveTab;
        vm.changeStatus = changeStatus;
        vm.isCurrentPlan = isCurrentPlan;
        vm.isCurrentPlanStyle = isCurrentPlanStyle;


        $scope.$on("deletedPlan", function () {
            loadPage();
        });


        /**** Main ****/


        vm.activeTab = 0;
        if (localStorage.getItem('activeTab')) {
            vm.activeTab = parseInt(localStorage.getItem('activeTab'));
        }



        Principal.hasAnyAuthority(['ROLE_PLAN_COORDINATOR']).then(function (result) {
            if (result) {
                vm.isPlanCoordinator = true;
            }
        });

        loadPage();

        vm.masterPlanInfo = $sce.trustAsHtml(
            '<h4>Operational plans</h4>' +
            '<p>Operational plans are timelines of Observations and Events corresponding to an LTP cycle, or a trajectory specific MLP</p>' +
            '<p>Creation of operational plans is restricted to SOC plan coordinators</p>' +
            '<p>Operational plans must comprise an Event Collection and an Operational set of observation definitions</p>'
        );
        vm.templatePlanInfo = $sce.trustAsHtml(
            '<h4>Floating Timelines</h4>' +
            '<p>Floating timelines are draft timelines of observations. Each observation is scheduled relative to the start of the timeline. ' +
            'It can be imported into any other plan and scheduled at any reference point within the plan, as long as the observation definition sets are the same.</p>' +
            '<p>They may be imported multiple times into one plan.</p>'
        );
        vm.soopPlanInfo = $sce.trustAsHtml(
            '<h4>SOOP Templates</h4>' +
            '<p>SOOP templates are blueprints of SOOPs for instantiation into operational plans. Each observation is scheduled relative to the start of the timeline. ' +
            'It can be instantiated into any other plan and scheduled at any reference point within the plan, as long as the observation definition sets are the same.</p>' +
            '<p>They may be instantiated multiple times into one plan.</p>'
        );
        vm.childPlanInfo = $sce.trustAsHtml(
            '<h4>Child plans</h4>' +
            '<p>Child plans are to be used to create draft timelines for importing into Operational Plans</p>' +
            '<p>For the sake of compatibility, child plans inherit the validity range and events (and their respective updates) from the parent plan, however no event set is saved or exported with the child plan.</p>' +
            '<p>A child plan may be imported into other plans if there are no compatibility issues and observation definition sets are the same.</p>' +
            '<p>On import, the absolute time of the planned observation will be maintained.</p>'
        );


        /**** Auxiliary Functions ****/

        function isCurrentPlan (validityRange, status, presentationProfile) {
            var isInRange = false;
            if (validityRange != null) {
                var now = new Date().getTime();
                var start = Date.parse(validityRange[0]);
                var end = Date.parse(validityRange [1]);
                isInRange = start<now && now<end;
            }

            return presentationProfile === "Long Term Planning" && isInRange && status === vm.allPlanStatus[1];
        }

        function isCurrentPlanStyle(validityRange, status, presentationProfile) {
            if (isCurrentPlan(validityRange, status, presentationProfile)) {
                return "background-color:#98FB98";
            }
        }

        function loadPage() {
            loadObservationDefinitions();
            loadEventCollections();
            loadPlanProfiles();
            loadPlanEventSchemas();
            loadSoopTypes();
            var labels = ["label-warning", "label-info", "label-danger"];
            Planning.getAllStatusForPlan(
                {}
                , function onSuccess(data, headers) {
                    for (var i = 0; i < data.length; i++) {
                        var status = data[i];
                        vm.allPlanStatus.push(status);
                        vm.planStatusLabel[status] =  labels[i];
                    }
                    loadAll();
                });

        }

        function setActiveTab(index) {
            localStorage.setItem('activeTab', index);
            vm.activeTab = index;
        }

        function errorCallback(error) {
            SoopkitchenUtils.prettyError(error);
        }

        function deletePlan(label, type) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/planning-delete-dialog.html',
                controller: 'PlanningDeleteController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    parameters: {
                        label: label,
                        planType : type
                    }
                }
            });
        }

        function renamePlan(label, type) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/rename-plan.html',
                controller: 'RenamePlanController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    parameters: {
                        label: label,
                        planType : type
                    }
                }
            }).result.then(
                {},
                function(status) {
                    if (status === 'success') {
                        location.reload();
                    }
                }
            );
        }

        function changeStatus(type, label) {
            var status = vm.planStatus[label];
            Planning.status(
                {
                    planType: type,
                    planLabel: label,
                    status: status
                });
        }

        function addValidityRange(plan) {
            EventCollections.getEventCollection(plan.eventCollectionsLabel, function (response) {
                var eventCollections = response.data;
                vm.planValidityRange[plan.eventCollectionsLabel] = [eventCollections.validityStartTime , eventCollections.validityEndTime];
            }, function () {

            });
        }

        function loadAll() {

            Planning.getAllLatestPlans(
                {
                    planType: PlanTypes['master']
                },
                function onSuccess(data, headers) {
                    vm.plans = [];
                    vm.parentPlanLabels = [];
                    vm.parentPlanLabels.push("");
                    for (var i = 0; i < data.length; i++) {
                        var plan = data[i];
                        vm.plans.push(plan);
                        vm.parentPlanLabels.push(plan.label);
                        vm.showDelta[plan.label] = false;
                        vm.moreInfo[plan.label] = $sce.trustAsHtml('Event Schema: <b><span id="schemaName">' + plan.schemaName + '</span></b><br>' +
                            'Schema Version: <b><span id="schemaVersion">' + plan.schemaVersion + '</span></b><br>' +
                            'Plan Profile: <b><span id="planProfile">' + plan.presentationProfile + '</span></b>');
                        vm.planStatus[plan.label] = plan.status;
                        addValidityRange(plan);

                    }
                    vm.plans = SoopkitchenUtils.sort(vm.plans, vm.predicate, vm.reverse);


                }, errorCallback);
            Planning.getAllLatestPlans(
                {
                    planType: PlanTypes['child']
                },
                function onSuccess(data, headers) {
                    vm.childPlans = [];
                    for (var i = 0; i < data.length; i++) {
                        var plan = data[i];
                        vm.childPlans.push(plan);
                        vm.showDelta[plan.label] = false;
                        vm.planStatus[plan.label] = plan.status;
                    }
                    vm.childPlans = SoopkitchenUtils.sort(vm.childPlans, vm.predicate, vm.reverse);
                }, errorCallback);

            Planning.getAllLatestPlans(
                {
                    planType: PlanTypes['template']
                },
                function onSuccess(data, headers) {
                    vm.templatePlansBaselined = [];
                    vm.templatePlansInProgress = [];
                    for (var i = 0; i < data.length; i++) {
                        var plan = data[i];
                        vm.showDelta[plan.label] = false;
                        if (plan.baselineVersion > 0) {
                            vm.templatePlansBaselined.push(plan);
                        } else {
                            vm.templatePlansInProgress.push(plan);
                        }
                        vm.planStatus[plan.label] = plan.status;
                    }
                    vm.templatePlansBaselined = SoopkitchenUtils.sort(vm.templatePlansBaselined, vm.predicateTemplateBaselined, vm.reverseTemplateBaselined);
                    vm.templatePlansInProgress = SoopkitchenUtils.sort(vm.templatePlansInProgress, vm.predicateTemplateInProgress, vm.reverseTemplateInProgress);
                }, errorCallback);

            Planning.getAllLatestPlans(
                {
                    planType: PlanTypes['soop']
                },
                function onSuccess(data, headers) {
                    vm.soopPlansBaselined = [];
                    vm.soopPlansInProgress = [];

                    for (var i = 0; i < data.length; i++) {
                        var plan = data[i];
                        vm.showDelta[plan.label] = false;
                        if (plan.baselineVersion > 0) {
                            vm.soopPlansBaselined.push(plan);
                        } else {
                            vm.soopPlansInProgress.push(plan);
                        }
                        vm.planStatus[plan.label] = plan.status;
                    }
                    vm.soopPlansBaselined = SoopkitchenUtils.sort(vm.soopPlansBaselined, vm.predicateSoopBaselined, vm.reverseSoopBaselined);
                    vm.soopPlansInProgress = SoopkitchenUtils.sort(vm.soopPlansInProgress, vm.predicateSoopInProgress, vm.reverseSoopInProgress);
                }, errorCallback
            );
        }

        function successLoadObservationDefinitionsOperational(response) {

            if (response.data) {
                var data = angular.isArray(response.data) ? response.data : angular.fromJson(response.data);
                var sortedData = SoopkitchenUtils.sort(data, 'timestamp', true);
                vm.observationDefinitions = [];
                vm.observationDefinitions.push("");
                vm.soopObservationDefinitions = [];
                vm.soopObservationDefinitions.push("");
                sortedData.forEach(function (item) {
                    vm.observationDefinitions.push(item.label);
                    vm.soopObservationDefinitions.push(item.label);
                });
                vm.selectedObservationDefinitions = vm.observationDefinitions[0];
                vm.selectedSoopObservationDefinitions = vm.soopObservationDefinitions[0];
            }
        }

        function failure(response) {
            SoopkitchenUtils.prettyError(response);
        }

        function successLoadObservationDefinitions(response) {
            if (response.data) {
                var data = angular.isArray(response.data) ? response.data : angular.fromJson(response.data);
                var sortedData = SoopkitchenUtils.sort(data, 'timestamp', true);
                vm.templateObservationDefinitions = [];
                vm.templateObservationDefinitions.push("");
                sortedData.forEach(function (item) {
                    vm.templateObservationDefinitions.push(item.label);
                });
                vm.selectedTemplateObservationDefinitions = vm.templateObservationDefinitions[0];
            }
        }

        function loadObservationDefinitions() {
            ObservationDefinitions.getObservationDefinitions(successLoadObservationDefinitionsOperational, failure, true);
            ObservationDefinitions.getObservationDefinitions(successLoadObservationDefinitions, failure, false);
        }

        function successLoadEventCollectionLabels(response) {
            if (response.data) {
                var data = angular.isArray(response.data) ? response.data : angular.fromJson(response.data);
                var sortedData = SoopkitchenUtils.sort(data, 'timestamp', true);
                vm.eventCollections = [];
                vm.eventCollections.push("");
                sortedData.forEach(function (item) {
                    vm.eventCollections.push(item.label);
                });
                vm.selectedEventCollections = vm.eventCollections[0];
            }
        }

        function loadEventCollections() {
            EventCollections.getEventCollections(successLoadEventCollectionLabels, failure);
        }

        function loadPlanProfiles() {
            PlanningEventsService.getProfiles(
                {},
                function successCallback(data) {
                    if (data) {
                        data = angular.fromJson(data);
                        vm.planProfiles = [];
                        vm.planProfiles.push("");
                        data.forEach(function (item) {
                            vm.planProfiles.push(item);
                        });
                        vm.selectedPlanProfile = vm.planProfiles[0];
                    }
                },errorCallback)
        }

        function loadSoopTypes() {
            Planning.getSoopTypes(
                {},
                function successCallback(data) {
                    if (data) {
                        data = angular.fromJson(data);
                        vm.soopTypes = [];
                        vm.soopTypes.push("");
                        data.forEach(function (item) {
                            vm.soopTypes.push(item);
                        });
                        vm.selectedSoopType = vm.soopTypes[0];
                    }
                },errorCallback)
        }

        function loadPlanEventSchemas() {
            PlanningEventsService.getEventSchemas(
                {},
                function successCallback(data) {
                    if (data) {
                        data = angular.fromJson(data);
                        vm.eventSchemas = [];
                        vm.eventSchemas.push("");
                        data.forEach(function (item) {
                            vm.eventSchemas.push(item);
                        });
                        vm.selectedEventSchema = vm.eventSchemas[0];
                    }
                },errorCallback)
        }

        function resetPlanForm() {
            vm.showCreateMenu[0] = false;
            vm.selectedObservationDefinitions = null;
            vm.selectedEventCollections = null;
            vm.selectedPlanProfile = null;
            vm.selectedEventSchema = null;
            vm.planLabel = null;
            vm.planId = null;
        }

        function createPlan() {
            Planning.create(
                {
                    planType: PlanTypes['master'],
                    obsDefLabel: vm.selectedObservationDefinitions,
                    eventCollectionsLabel: vm.selectedEventCollections,
                    planProfile: vm.selectedPlanProfile,
                    eventSchema: vm.selectedEventSchema,
                    planLabel: vm.planLabel,
                    planId: vm.planId
                },
                function successCallback() {
                    resetPlanForm();
                    loadAll();
                },errorCallback
            );
        }

        function resetChildPlanForm() {
            vm.showCreateMenu[1] = false;
            vm.childPlanLabel = null;
            vm.selectedParentLabel = null;
        }

        function createChildPlan() {
            Planning.create(
                {
                    planType: PlanTypes['child'],
                    planLabel: vm.childPlanLabel,
                    parentLabel: vm.selectedParentLabel
                },
                function successCallback(response) {
                    resetChildPlanForm();
                    loadAll();
                }, errorCallback);
        }

        function resetTemplatePlanForm() {
            vm.showCreateMenu[2] = false;
            vm.selectedTemplateObservationDefinitions = null;
            vm.templateDurationString = null;
            vm.templatePlanLabel = null;
        }

        function createTemplatePlan() {
            Planning.create(
                {
                    planType: PlanTypes['template'],
                    obsDefLabel: vm.selectedTemplateObservationDefinitions,
                    duration: SoopkitchenUtils.timeToSeconds(vm.templateDurationString),
                    planLabel: vm.templatePlanLabel
                },
                [],
                function successCallback(response) {
                    resetTemplatePlanForm();
                    loadAll();
                }, errorCallback);
        }

        function resetSoopPlanForm() {
            vm.showCreateMenu[3] = false;
            vm.selectedSoopObservationDefinitions = null;
            vm.soopDurationString = null;
            vm.soopPlanLabel = null;
            vm.selectedSoopType = null;
            vm.selectedSoopLeadInstrument = null;
        }

        function createSoopPlan() {
            Planning.create(
                {
                    planType: PlanTypes['soop'],
                    obsDefLabel: vm.selectedSoopObservationDefinitions,
                    duration: SoopkitchenUtils.timeToSeconds(vm.soopDurationString),
                    planLabel: vm.soopPlanLabel,
                    leadInstrument: vm.selectedSoopLeadInstrument,
                    soopType: vm.selectedSoopType,
                },
                [],
                function successCallback(response) {
                    resetSoopPlanForm();
                    loadAll();
                }, errorCallback);
        }
        function sortPlanTable() {
            vm.plans = SoopkitchenUtils.sort(vm.plans, vm.predicate, vm.reverse);
            $scope.$apply();
        }

        function sortChildPlanTable() {
            vm.childPlans = SoopkitchenUtils.sort(vm.childPlans, vm.predicate, vm.reverse);
            $scope.$apply();
        }

        function sortTemplatePlanTableInProgress() {
            vm.templatePlansInProgress = SoopkitchenUtils.sort(vm.templatePlansInProgress, vm.predicateTemplateInProgress, vm.reverseTemplateInProgress);
            $scope.$apply();
        }

        function sortTemplatePlanTableBaselined() {
            vm.templatePlansBaselined = SoopkitchenUtils.sort(vm.templatePlansBaselined, vm.predicateTemplateBaselined, vm.reverseTemplateBaselined);
            $scope.$apply();
        }

        function sortSoopPlanTableInProgress() {
            vm.soopPlans = SoopkitchenUtils.sort(vm.soopPlansInProgress, vm.predicateSoopInProgress, vm.reverseSoopInProgress);
            $scope.$apply();
        }
        function sortSoopPlanTableBaselined() {
            vm.soopPlans = SoopkitchenUtils.sort(vm.soopPlansBaselined, vm.predicateSoopBaselined, vm.reverseSoopBaselined);
            $scope.$apply();
        }
    }
})();
